<div class="ttmodal" id="favouriteWindow">
  <div id="favouriteWindowHeader" class="ttmodal__header" >
    <span class="ttmodal__title">Create My Favourite</span>
    <div class="panel__header__button-container" id="closeButton">
      <a class="button waves-effect" (click)="onCloseClick()">
              <i class="material-icons button__icon">cancel</i>
              <span class="button__text">Close</span>
          </a>
    </div>
  </div>

  <div class="ttmodal__body">
    <div style="">
      <div class="input-container">
        <span class="label" style="width: 190px;">Name of Favourite</span>
        <mat-form-field style="width:380px">
          <input matInput type="text" [(ngModel)]="favName" #favName_="ngModel" class="get-Input">
        </mat-form-field>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Customers to Include</span>
        <mat-select placeholder="Select Customers" multiple style="width: 345px" [(ngModel)]="customerIds"
          (selectionChange)="loadJobsites()">
          <mat-option *ngFor="let item of customerList;" [value]="item.Id" >
            {{item.Name}}</mat-option>
        </mat-select>
        

        <!--matchips for customerlist-->
        <!-- <mat-form-field class="demo-chip-list">
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let item of customerIds" [selectable]="selectable" [removable]="removable"
              (remove)="remove(item.Id)">
              {{item.Name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </mat-form-field> --> 
      
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Jobsite to Include</span>
        <mat-select placeholder="Select Jobsites"  multiple style="width: 345px" [(ngModel)]="jobsiteId" (selectionChange)="LoadImplementTypeList(1)">
          <mat-option *ngFor="let item of jobsiteList" [value]="item.Id">{{item.Name}}</mat-option>
        </mat-select>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Families to Include</span>
        <mat-select placeholder="Select Families"  multiple style="width: 345px" (selectionChange)="loadModelList()" [(ngModel)]="familyId"  (selectionChange)="LoadImplementTypeList(1)">
          <mat-option *ngFor="let item of _favouriteDialogService.availableFamilyList" [value]="item.Id">{{item.Name}}
          </mat-option>
        </mat-select>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Makes to Include</span>
        <mat-select placeholder="Select Makes"  multiple style="width: 345px" (selectionChange)="loadModelList()" [(ngModel)]="makesId"  (selectionChange)="LoadImplementTypeList(1)">
          <mat-option *ngFor="let item of makeList" [value]="item.Id">{{item.Name}}</mat-option>
        </mat-select>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Models to Include</span>
        <mat-select placeholder="Select Models"  multiple style="width: 345px" [(ngModel)]="modelId"  (selectionChange)="LoadImplementTypeList(1)">
          <mat-option *ngFor="let item of modelList" [value]="item.Id">{{item.Name}}</mat-option>
        </mat-select>

        <!-- <mat-select placeholder="Toppings" [formControl]="toppings" multiple style="width: 345px" >
            <mat-option *ngFor="let topping of toppingList" [value]="topping">{{topping}}</mat-option>
          </mat-select> -->
      </div>


      <div class="input-container">
        <!-- <span class="label" style="width: 190px;">Default View</span>
        <mat-radio-group name="type" [(ngModel)]="TypeID">
          <mat-radio-button [value]="1" #Cracks>Cracks</mat-radio-button>
          <mat-radio-button [value]="2" #Eval>Eval Code</mat-radio-button>
          <mat-radio-button [value]="3" #Eval>Percent Worn</mat-radio-button>
        </mat-radio-group> -->
      </div>

      <div class="input-container">
        <span class="label" style="width: 300px"></span>
        <span class="label" style="width: 0px">Order</span>
        <span class="label" style="width: 0px">Show/Hide</span>     
      </div>

     
      <div class="input-container">
        <!-- <span class="label" style="width: 190px">Implement Listing and Order</span> -->
       <!-- <mat-selection-list  class="implementList"  [(ngModel)]="implementId">
          <mat-list-option *ngFor="let item of implementList" [value]="item.Id">
            {{item.Name}} 
          </mat-list-option>
        </mat-selection-list> -->

        <!-- <mat-selection-list  class="implementList" [(ngModel)]="implementTypeIds">
            <a mat-list-item *ngFor="let item of filteredList;" >
          
              <h3 matLine> {{item.Name}}</h3>
              <button mat-icon-button (click)="down($event, item)">
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button mat-icon-button (click)="up($event, item)">
                  <mat-icon>arrow_upward</mat-icon>
                </button>

                <mat-checkbox  (change)="onImplementListControlChanged(item.Id, $event,item)"  [checked]="item.Check" [value]="item.Id"></mat-checkbox>
            </a>
          </mat-selection-list > -->

         
              
        <mat-selection-list  class="implementList" [(ngModel)]="ColumnIds">
            <a mat-list-item *ngFor="let item of GETDashboardColumnsList; let i = index" >            
              <h3 matLine> {{item.Name == 'condition'? 'Worn': item.Name}} </h3>
              
              <button  mat-icon-button (click)="moveDown(i)">
                <mat-icon [class.button-hide]="isLastComponentInList(item, i)">arrow_downward</mat-icon>
              </button>
              <button mat-icon-button (click)="moveUp(i)" style="margin-right: 15px;" >
                  <mat-icon [class.button-hide]="isFirstComponentInList(item, i)">arrow_upward</mat-icon>
              </button>             
                <mat-checkbox [(ngModel)]="item.ckecked" (change)="onColumnControlChanged( $event,item.columnId, i)" ></mat-checkbox>          
              </a>
            
          </mat-selection-list >
        </div>
        <!-- <div>
            <a class="button" style="background: #98C6E0  " (click)="LoadImplementTypeList(1)">
                <i class="material-icons button__icon">replay</i>
                <span class="button__text">Load Implement</span>
            </a>
      </div> -->
      <div class="flex-container column" style="margin-left: 75%;">
          <span  *ngIf="favId"class="label" style="width: 190px;">Save Updates</span>
        <img *ngIf="favId"Class="flex-item" src="Content\Images\Icons\Edit.png" style="width: 75px; cursor: pointer;" (click)="LoadImplementTypeList(2)">
        <span *ngIf="!favId" class="label" style="width: 190px;margin-left:9%;">Save</span>
        <img  *ngIf="!favId" class="flex-item" src="Content\Images\Icons\Save.png" style="width:75px;cursor: pointer;" (click)="SaveFavourite()">
      </div>
      

    </div>
  </div>
</div>